import config from '../../../config/config-default';

const getClientToken = async () => {
	const response = await fetch(`${config.apiUri}/bookings/get-token`, {
		headers: {
			Accept: 'application/json',
		},
	});

	return response.json();
};

const loadScript = async (src) => {
	return new Promise((resolve) => {
		const script = document.createElement('script');
		script.async = true;
		script.defer = true;
		script.onload = () => {
			resolve();
		};
		document.head.appendChild(script);
		script.src = src;
	});
};

const processBraintree = async () => {
	try {
		const payload = await window[
			config.globalScope
		].dropinInstance.requestPaymentMethod();

		const paymentNonce = document.getElementById('payment-nonce');
		paymentNonce.value = payload.nonce;

		const dropinContainer = document.getElementById('dropin-container');
		dropinContainer.classList.remove('is-invalid');

		const form = document.getElementById('form');
		const paymentMethods = form.querySelectorAll(
			'input[name="payment_method"]',
		);
		paymentMethods.forEach((radio) => radio.setAttribute('disabled', ''));
		const creditCardOption = document.getElementById('payment-method-3');
		if (creditCardOption) {
			creditCardOption.checked = true;
		}
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Error processing Braintree payment:', error);
	}
};

const initBraintree = async () => {
	try {
		const [token] = await Promise.all([
			getClientToken(),
			loadScript(
				'https://js.braintreegateway.com/web/dropin/1.46.0/js/dropin.min.js',
			),
		]);
		window[config.globalScope].clientToken = token.data;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Error initializing Braintree:', error);
	}
};

const initBraintreeClient = async () => {
	if (window[config.globalScope].clientToken) {
		try {
			const dropinInstance = await window.braintree.dropin.create({
				authorization: window[config.globalScope].clientToken,
				container: '#dropin-container',
				card: {
					overrides: {
						fields: {
							number: {
								// May not need this on production, supported card brands may be determined by Braintree account settings
								supportedCardBrands: {
									visa: true,
									mastercard: true,
									'american-express': false,
									discover: false,
									jcb: false,
								},
							},
						},
					},
				},
			});
			window[config.globalScope].dropinInstance = dropinInstance;

			dropinInstance.on('paymentMethodRequestable', () => {
				processBraintree();
			});

			const form = document.getElementById('form');
			const backButton = form.querySelector('a[data-current="4"]');
			if (backButton) {
				backButton.classList.add('disabled');
				backButton.setAttribute('tabindex', '-1');
				backButton.setAttribute('aria-disabled', 'true');
				backButton.addEventListener('click', (e) => {
					e.preventDefault();
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error initializing Braintree client:', error);
		}
	}
};

export { initBraintree, initBraintreeClient };
